import './DefaultReports.css';
import React from 'react';
import { t } from 'i18next';
import Loading from '../../loading/Loading';
import { LOADER_SMALL } from '../../../constants';

const { keys } = Object;

const detailHtml = (title, data) => (data ? (
  <span className="details">
    {t(title, {
      value: data
    })}
  </span>
) : <span><Loading size={LOADER_SMALL} /></span>);

const DefaultReport = ({ reportKey, data }) => {
  const value = data[reportKey] ? data[reportKey].value : null;
  const isWithDetails = data[reportKey] && data[reportKey].details;
  const detailsTitle = isWithDetails ? data[reportKey].details.title : null;
  const detailsData = isWithDetails ? data[reportKey].details.data : null;

  return (
    <div>
      <span>
        {t(reportKey)}
      </span>
      <span>:</span>
      {value ? <span className={`${(value === t('unableToFetchData')) ? 'unable-to-fetch-data' : ''}`}>{value}</span> : <span><Loading size={LOADER_SMALL} /></span>}
      {isWithDetails ? detailHtml(detailsTitle, detailsData) : null }
    </div>
  );
};

const DefaultReports = ({ data }) => (
  <div className="DefaultReports">
    {keys(data).map(key => (
      <DefaultReport key={key} reportKey={key} data={data} />
    ))}
  </div>
);

export default DefaultReports;
